export default "__VITE_ASSET__D2PiFI$s__"